// OAuth client id from Google Cloud Console (APIs & Services -> Credentials).
// It is public by design (it ends up in every page that shows the button),
// so it lives in the code rather than in a build-time secret.
// Empty string: the "Continue with Google" button is hidden.
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '996524643789-31s3un1t851orlcipreb6b0829mhvt30.apps.googleusercontent.com'
